<template>
  <div class='s_flex_center m-b-20'>
    <a-radio-group v-model:value="type" @change="onChange">
      <a-radio-button :value="1">
        会员营销
      </a-radio-button>
      <a-radio-button :value="2">
        客户关怀
      </a-radio-button>
      <a-radio-button :value="3">
        消息通知
      </a-radio-button>
    </a-radio-group>
  </div>
  <a-table :pagination='false' :loading='loding' bordered rowKey="id" :columns='columns' :data-source='list'>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click="choose(record)">
        选择
      </a-button>
    </template>
  </a-table>
</template>
<script>
  import { getSmsCaseTemplate } from '@/api/message'
  import { onMounted, reactive, toRefs } from 'vue'
  export default {
    setup(props, { emit }) {
      const state = reactive({
        list: [],
        type: 1,
        loding: false,
        columns: [
          {
            title: "内容",
            dataIndex: "content",
            key: "content",
            ellipsis: true,
          },
          {
            title: "操作",
            key: "action",
            slots: { customRender: "action" },
            width: 120
          },
        ]
      })
      const initData = async () => {
        state.loding = true
        let result = await getSmsCaseTemplate({ type: state.type }).then(res => res.data).catch(error => error)
        state.loding = false
        state.list = result.data
      }
      // 切换类型
      const onChange = () => {
        initData()
      }
      onMounted(() => {
        initData()
      })
      // 选择模板
      const choose = (data) => {
        emit('success', data)
      }
      return {
        ...toRefs(state),
        onChange,
        choose
      }
    }
  }
</script>